import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";

function Filters(props) {
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    d: "M.875 6.201H9.34a3.286 3.286 0 006.39 0h3.395a.75.75 0 000-1.5h-3.388a3.286 3.286 0 00-6.405 0H.875a.75.75 0 000 1.5zm11.66 1.018c-.981 0-1.777-.79-1.785-1.77v-.014a1.785 1.785 0 111.785 1.784zM9.25 14.547a.784.784 0 000 .02 1.785 1.785 0 01-3.57-.013 1.785 1.785 0 013.57-.007zm-4.983.763l-3.388.016a.75.75 0 01-.007-1.5l3.394-.016a3.286 3.286 0 016.398-.001l8.463.017a.75.75 0 01-.003 1.5l-8.46-.017a3.286 3.286 0 01-6.397.001z",
    clipRule: "evenodd"
  }));
}

export { Filters };
//# sourceMappingURL=Filters.js.map